export const viewRoutes = [
  {
    title: 'Home',
    path: '/',
  },
  {
    title: 'About us',
    path: '/about-us',
  },
  {
    title: 'Create your plan',
    path: '/create-plan',
  },
];

export const apiRoutes = {
  contents: '/api/v1/contents/:id',
};
